import { Preference, PreferenceItem } from '@/context/auth/types';
import { Property } from '@/types';
import { AppState } from '@/types/store';
import { useSelector } from 'react-redux';

function getDefaultPreference(property: Property) {
  const budget: PreferenceItem<number> = {
    prefer: 900000,
    limit: 2500000,
    higherIsBetter: false,
  };

  const propertyType: PreferenceItem<string[]> = {
    prefer: [],
    limit: [],
    higherIsBetter: false,
  };

  const bedroom: PreferenceItem<number> = {
    prefer: 4,
    limit: 3,
    higherIsBetter: true,
  };

  const bathroom: PreferenceItem<number> = {
    prefer: 3,
    limit: 2,
    higherIsBetter: true,
  };

  const parking: PreferenceItem<number> = {
    prefer: 3,
    limit: 2,
    higherIsBetter: true,
  };

  const annualTax: PreferenceItem<number> = {
    prefer: 4000,
    limit: 10000,
    higherIsBetter: false,
  };

  const maintenanceFee: PreferenceItem<number> = {
    prefer: 0,
    limit: 0,
    higherIsBetter: false,
  };

  if (property.propertyClass === 'Condo' && property.type !== 'Lease') {
    budget.prefer = 700000;
    budget.limit = 1500000;
    bedroom.prefer = 2;
    bedroom.limit = 1;
    bathroom.prefer = 2;
    bathroom.limit = 1;
    parking.prefer = 2;
    parking.limit = 1;
    annualTax.prefer = 2000;
    annualTax.limit = 6000;
    maintenanceFee.prefer = 500;
    maintenanceFee.limit = 1000;
  } else if (property.propertyClass !== 'Condo' && property.type === 'Lease') {
    budget.prefer = 2500;
    budget.limit = 3000;
    bedroom.prefer = 3;
    bedroom.limit = 2;
    bathroom.prefer = 3;
    bathroom.limit = 2;
    parking.prefer = 3;
    parking.limit = 2;
    annualTax.prefer = 0;
    annualTax.limit = 0;
    maintenanceFee.prefer = 0;
    maintenanceFee.limit = 0;
  } else if (property.propertyClass === 'Condo' && property.type === 'Lease') {
    budget.prefer = 2000;
    budget.limit = 2500;
    bedroom.prefer = 2;
    bedroom.limit = 1;
    bathroom.prefer = 2;
    bathroom.limit = 1;
    parking.prefer = 2;
    parking.limit = 1;
    annualTax.prefer = 0;
    annualTax.limit = 0;
    maintenanceFee.prefer = 0;
    maintenanceFee.limit = 0;
  }

  const preference: Preference = {
    budget,
    propertyType,
    bedroom,
    bathroom,
    parking,
    annualTax,
    maintenanceFee,
  };

  return preference;
}

export default function usePreference(property: Property): Preference {
  const state = useSelector((state: AppState) => state.auth);

  if (state.preferenceLoading) {
    return {};
  }

  if (!state.preference) {
    const preference = getDefaultPreference(property);
    return preference;
  }

  return state.preference;
}
